<div class="crud-item-page">
  <form [formGroup]="form">

    <section>
      <mat-divider></mat-divider>
      <div class="crud-item-section">
        <app-asset-item [readOnly]="readOnly" [createMode]="createMode" [item]="item.asset" composedAssetClass="Firearm"
          [inputFormDisplay]="assetInputFormDisplay" [locationSelectionListFilterLoad]="locationSelectionListFilterLoad"
          [initialFormCustomiser]="initialAssetFormCustomiser" [fieldDefaultsFormsCustomiser]="fieldDefaultsAssetFormsCustomiser">
        </app-asset-item>
      </div>
    </section>

    <section>
      <mat-divider></mat-divider>
      <div class="crud-item-section">

        <span>
          <mat-form-field matTooltip="Select a Current Assignment Firearm Assignment Type from the list"
            [matTooltipDisabled]="disabledTooltip(this.currentAssignmentFirearmAssignmentType)">
            <mat-label i18n="@@type.Firearm.currentAssignmentFirearmAssignmentType">Current Assignment Type</mat-label>
            <mat-select formControlName="currentAssignmentFirearmAssignmentType"
              id="currentAssignmentFirearmAssignmentType" [ngModel]="item.currentAssignmentFirearmAssignmentType"
              #currentAssignmentFirearmAssignmentType placeholder="Current Assignment Firearm Assignment Type"
              [disabled]="true">
              <mat-option>Any</mat-option>
              <mat-option
                *ngFor="let currentAssignmentFirearmAssignmentType of currentAssignmentFirearmAssignmentTypeSelectionList"
                [value]="currentAssignmentFirearmAssignmentType.code">
                {{currentAssignmentFirearmAssignmentType.meaning}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </span>

            
      <span [ngClass]="storageTypeHiddenClass()">
        <mat-form-field matTooltip="Select a Current Assignment Firearm Assignment Storage Type from the list" [matTooltipDisabled]="disabledTooltip(this.currentAssignmentFirearmAssignmentStorageType)">
          <mat-label i18n="@@type.Firearm.currentAssignmentFirearmAssignmentStorageType">Storage Type</mat-label>
          <mat-select formControlName="currentAssignmentFirearmAssignmentStorageType" id="currentAssignmentFirearmAssignmentStorageType"              
              [ngModel]="item.currentAssignmentFirearmAssignmentStorageType" #currentAssignmentFirearmAssignmentStorageType              
              placeholder="Storage Type" [disabled]="true">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let currentAssignmentFirearmAssignmentStorageType of currentAssignmentFirearmAssignmentStorageTypeSelectionList" [value]="currentAssignmentFirearmAssignmentStorageType.code">
              {{currentAssignmentFirearmAssignmentStorageType.meaning}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>


        <span>
          <mat-form-field matTooltip="Current Assignment Email"
            [matTooltipDisabled]="disabledTooltip(this.currentAssignmentEmail)" class="crud-item-input-wider">
            <mat-label i18n="@@type.Firearm.currentAssignmentEmail">Current Assignment Email</mat-label>
            <input matInput formControlName="currentAssignmentEmail" id="currentAssignmentEmail"
              [ngModel]="item.currentAssignmentEmail" #currentAssignmentEmail placeholder="Current Assignment Email"
              disabled>
          </mat-form-field>
        </span>

        <span>
          <span>
            <mat-slide-toggle floatLabel="always" appearance="none" color="primary"
                formControlName="personalFirearm" id="personalFirearm"              
                (ngModelChange)="personalFirearmChanging($event)" [(ngModel)]="item.personalFirearm"              
                (ngModelChange)="personalFirearmChanged($event)" #personalFirearm i18n="@@type.Firearm.personalFirearm">
                Personal Firearm          </mat-slide-toggle>        
          </span>
        </span>
  
      </div>
      <mat-divider></mat-divider>
      <div class="crud-item-section">

        <span>
          <mat-form-field matTooltip="Select a Firearm Type from the list"
            [matTooltipDisabled]="disabledTooltip(this.firearmType)">
            <mat-label i18n="@@type.Firearm.firearmType">Firearm Type</mat-label>
            <mat-select formControlName="firearmType" id="firearmType" (ngModelChange)="firearmTypeChanging($event)"
              [(ngModel)]="item.firearmType" (ngModelChange)="firearmTypeChanged($event)" #firearmType
              placeholder="Firearm Type">
              <mat-option>Any</mat-option>
              <mat-option *ngFor="let firearmType of firearmTypeSelectionList" [value]="firearmType.code">
                {{firearmType.meaning}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </span>

        <span>
          <mat-form-field matTooltip="Select a Calibre from the list"
            [matTooltipDisabled]="disabledTooltip(this.calibre)">
            <mat-label i18n="@@type.Firearm.calibre">Calibre</mat-label>
            <mat-select formControlName="calibre" id="calibre" (ngModelChange)="calibreChanging($event)"
              [(ngModel)]="item.calibre" (ngModelChange)="calibreChanged($event)" #calibre placeholder="Calibre">
              <mat-option>Any</mat-option>
              <mat-option *ngFor="let calibre of calibreSelectionList" [value]="calibre.code">
                {{calibre.meaning}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </span>


        <span>
          <mat-form-field matTooltip="Select a Lifecycle State from the list" [matTooltipDisabled]="disabledTooltip(this.lifecycleState)">
            <mat-label i18n="@@type.Firearm.lifecycleState">Lifecycle State</mat-label>
            <mat-select formControlName="lifecycleState" id="lifecycleState"              
                [ngModel]="item.lifecycleState" #lifecycleState              
                placeholder="Lifecycle State" [disabled]="true">
              <mat-option>Any</mat-option>
              <mat-option *ngFor="let lifecycleState of lifecycleStateSelectionList" [value]="lifecycleState.code">
                {{lifecycleState.meaning}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </span>

        <span>
          <span>
            <mat-slide-toggle floatLabel="always" appearance="none" color="primary" formControlName="suspended"
              id="suspended" (ngModelChange)="suspendedChanging($event)" [(ngModel)]="item.suspended"
              (ngModelChange)="suspendedChanged($event)" #suspended i18n="@@type.Firearm.suspended">
              Suspended </mat-slide-toggle>
          </span>
        </span>
      </div>
      <mat-divider *ngIf="item.asset"></mat-divider>

      <app-asset-tags-control *ngIf="item.asset" [item]="item?.asset" [readOnly]="readOnly" [createMode]="createMode"
        [parentAssetComponent]="assetItem" composedAssetClass="Firearm"></app-asset-tags-control>

      <mat-divider *ngIf="item.asset"></mat-divider>

      <app-asset-additional-info-control *ngIf="item.asset" [item]="item?.asset" [readOnly]="readOnly"
        [createMode]="createMode" [parentAssetComponent]="assetItem"></app-asset-additional-info-control>

      <mat-divider *ngIf="item.asset"></mat-divider>

      <app-asset-aspects-control *ngIf="item.asset" [item]="item?.asset" [readOnly]="readOnly" [createMode]="createMode"
        [parentAssetComponent]="assetItem"></app-asset-aspects-control>

    </section>

  </form>
</div>